import { createContext } from 'react';

import { AppEventEmitter } from '../app-event-emitter';

export const AppEventEmitterContext =
  createContext<AppEventEmitter<unknown> | null>(new AppEventEmitter());
